const DEFAULT_NICKNAME = 'Miembro anónimo'

const LANGUAGES = {
    es: 'es',
    en: 'en',
    ca: 'ca',
}
const DEFAULT_LANGUAGE = LANGUAGES.en

const AVATARS = [
    'maskHeader',
    'orangeMaskRedHair',
    'blueMaskRedNose',
    'femaleMaskRedHair',
    'orangeBlueMask',
    'harlequinMaskRedNose',
    'greenMaskBrownEars',
    'sunGlassesMask',
]

const LEADERBOARDS_TARGETS = {
    TREE_TOTAL: 'TREE_TOTAL',
    TREE_MONTHLY: 'TREE_MONTHLY',
}

const VERIFICATION_STATUS = {
    success: 'success',
    verified: 'verified',
    failed: 'failed',
}

export { LANGUAGES,
    DEFAULT_NICKNAME,
    DEFAULT_LANGUAGE,
    AVATARS,
    LEADERBOARDS_TARGETS,
    VERIFICATION_STATUS }
